import React, { useCallback, useState } from "react";
import { SearchBox, withSearch } from "@elastic/react-search-ui";
import { useTranslation } from "react-i18next";
import SearchFormComponent from "./SearchFormComponent";
import queryString from "../../../../helpers/queryString";
import config from "../../../../config";

const SelectCategoryComponent = ({
  setFilter,
  filters,
  removeFilter,
  fieldName = "field_faq_product_categories",
}) => {
  const initialFilter =
    filters.filter((f) => f.field === fieldName)?.[0]?.values?.[0] || "";

  const [filterV, setFilterV] = useState(initialFilter);
  const setCategoryFilter = useCallback(
    (filterV, searchValue) => {
      const searchJson = {
        q: searchValue,
      };

      if (filterV) {
        const filters = [
          {
            field: fieldName,
            values: [filterV || ""],
            type: "all",
          },
        ];
        searchJson["filters"] = filters;
      }

      const redirectUrl = `${config.faqSearchAppUrl}?${queryString.stringify(
        searchJson,
      )}`;

      window.location.href = redirectUrl;
    },
    [fieldName],
  );

  return (
    <>
      <SearchBox
        searchAsYouType={false}
        autocompleteSuggestions={true}
        view={(props) => (
          <SearchFormComponent
            {...props}
            {...{ setCategoryFilter, filterV, setFilterV, fieldName }}
          />
        )}
      />
    </>
  );
};

const SelectCategory = withSearch(({ setFilter, filters, removeFilter }) => ({
  setFilter,
  filters,
  removeFilter,
}))(SelectCategoryComponent);

const OmronSearchBox = () => {
  const { t } = useTranslation();
  return (
    <div>
      <h1 className="c-title--subtitle-border">{t("Search by keyword")}</h1>
      <SelectCategory />
    </div>
  );
};

export default OmronSearchBox;
